export const UPDATE_USER = 'UPDATE_USER';
export const GET_CONFIGURATION = 'GET_CONFIGURATION';